export const LANGS = {
  FR: {
    id: 'fr',
    nameFr: 'Français',
    nameEn: 'French'
  },
  EN: {
    id: 'en',
    nameFr: 'Anglais',
    nameEn: 'English'
  }
}

export const LS_LANGUAGE_KEY = 'tmz_lang'
